import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogModule,
} from '@angular/material/dialog';
import { CentrexSdaModel } from 'src/app/models/centrex-sda.model';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { GumOrganizationsService } from 'src/app/services/gumservices/gum-organizations.service';
import { Organization } from 'src/app/models/organization.model';

interface ClientSdaSummary {
  organizationId: string;
  clientName: string;
  clientNumber: string;
  engagementDate: string;
  duration: string;
  nbSdas: number;
  status: string;
}

@Component({
  selector: 'app-services-sda-dialog',
  standalone: true,
  templateUrl: './services-sda-dialog.component.html',
  styleUrl: './services-sda-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatDialogModule, MatTableModule, MatButtonModule, MatIconModule],
})
export class ServicesSdaDialogComponent {
  displayedColumns: string[] = [
    'clientName',
    'clientNumber',
    'engagementDate',
    'duration',
    'metrics',
    'status',
    'actions',
  ];
  clientSummaries: ClientSdaSummary[] = [];

  constructor(
    public dialogRef: MatDialogRef<ServicesSdaDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CentrexSdaModel[],
    private gumOrganizationsService: GumOrganizationsService
  ) {
    this.buildSummary(data);
  }

  private buildSummary(sdas: CentrexSdaModel[]): void {
    const grouped = new Map<string, CentrexSdaModel[]>();

    for (const sda of sdas) {
      if (!grouped.has(sda.organizationId!)) {
        grouped.set(sda.organizationId!, []);
      }
      grouped.get(sda.organizationId!)!.push(sda);
    }

    const allOrgIds = Array.from(grouped.keys());

    this.gumOrganizationsService
      .getOrganisations(false)
      .subscribe((allOrgs: Organization[]) => {
        const orgMap = new Map(allOrgs.map((o) => [o.id, o.display]));

        this.clientSummaries = Array.from(grouped.entries()).map(
          ([orgId, sdaList]) => {
            return {
              organizationId: orgId,
              clientName: orgMap.get(orgId) ?? `Client ${orgId.slice(-4)}`,
              clientNumber: '-', // en attente
              engagementDate: '-', // à venir via abonnement
              duration: '-', // idem
              nbSdas: sdaList.length,
              status: 'Actif', // ou à enrichir
            };
          }
        );
      });
  }

  goToNexusCentrex(orgId: string): void {
    const url = `https://nexus-centrex.tel4btest.com/`;
    window.open(url, '_blank');
  }

  toggleAccess(orgId: string): void {
    console.log(`TODO: Désactiver ou réactiver le module pour ${orgId}`);
  }

  close(): void {
    this.dialogRef.close();
  }
}
